import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "overflow",
  "data-aos": "fade-down",
  "data-aos-delay": "150",
  "data-aos-duration": "800"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RenderingRandselBag = _resolveComponent("RenderingRandselBag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
      return _createVNode(_Transition, {
        key: i,
        name: _ctx.direction
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_RenderingRandselBag, {
            cameraPos: i - 1
          }, null, 8, ["cameraPos"]), [
            [_vShow, _ctx.cameraPos == i - 1]
          ])
        ]),
        _: 2
      }, 1032, ["name"])
    }), 64))
  ]))
}